 import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Subject, take, delay } from 'rxjs';
import { TemplateText, Options,} from 'src/app/_objects/report-template';
import { INPUT_TYPES, SUMMARY_DYNAMIC_SELECT_ITEM} from 'src/app//app.constants';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatTableDataSource } from '@angular/material/table';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
    selector: 'app-texts-info-input',
    templateUrl: './texts-info-input.component.html',
    styleUrls: ['./texts-info-input.component.scss'],
    standalone: false
})
export class TextsInfoInputComponent implements OnInit, OnDestroy, OnChanges {

  @Input() value: TemplateText;
  @Input() width: number;
  @Input() displayOptions: { label: string, value: string }[];
  @Input() typeOptions: { label: string, value: string }[];

  @Output() inputValue: EventEmitter<TemplateText> = new EventEmitter();

  public optionDataSource: MatTableDataSource<Options> = new MatTableDataSource();
  public formGroup = new UntypedFormGroup({
    typeField: new UntypedFormControl(),
    textField: new UntypedFormControl(),
    formatField: new UntypedFormControl(),
    dynamicDataField: new UntypedFormControl(),
    dynamicIdField: new UntypedFormControl(),
    inputTypeField: new UntypedFormControl(),
    editableIdField: new UntypedFormControl(),
    validationField: new UntypedFormControl(),
    maxLengthField: new UntypedFormControl(),
    requiredField: new UntypedFormControl(),
    radioTypeField: new UntypedFormControl(),
    radioLabelField: new UntypedFormControl(),
    labelField: new UntypedFormControl(),
    valueField: new UntypedFormControl(),
    inputGroupField: new UntypedFormControl(),
    multiSelectDelimiterField: new UntypedFormControl()
  });

  public isShowOverlay = false;
  public isOptionsError = false;
  private subject = new Subject();

  public inputTypeOptions = INPUT_TYPES;
  public radioTypeOptions = [
    {label: 'check', value: 'check'},
    {label: 'circle', value: 'circle'},
    {label: 'disc', value: 'disc'}
  ];
  public delimiterOptions = [
    {label: 'comma', value: 'comma'},
    {label: 'new line', value: 'newline'}
  ];
  public dynamicIdOptions = SUMMARY_DYNAMIC_SELECT_ITEM;
  public editTypeOptions = [
    { label: 'dynamic', value: 'dynamic' }
  ];

  constructor() { }

  ngOnInit(): void {
    this.dynamicIdOptions = this.displayOptions;
    this.editTypeOptions = this.typeOptions;
    this.optionDataSource.data = this.value.options;
  }

  ngOnChanges(): void {}

  ngOnDestroy() {
    if (this.subject) {
      this.subject.unsubscribe();
      this.subject = null;
    };
  }

  showOverlay() {
    this.isShowOverlay = true;
  }

  hideOverlay() {
    this.subject.pipe(take(1), delay(300)).subscribe((_) => {
      this.isShowOverlay = false;
    });

    this.subject.next(null);
  }

  selectValue(value: string) {
    this.formGroup.controls["typeField"].setValue(value);
  }

  onChangeAtCheckBox(event: MatCheckboxChange) {
    this.value.validation.required = event.checked;
  }

  public addObject() {
    if (!this.value.options) {
      this.value.options = [];
    }
    if (this.value.options.length < 100) {
      this.value.options.push({ label: '', value: '' });
      this.onChangeAtMulti();
      this.isOptionsError = false;
    }
  }
  public deleteObject(index: number) {
    this.value.options.splice(index, 1);
    this.onChangeAtMulti();
    if (this.value.options.length === 0) {
      this.isOptionsError = false;
    }
  }

  public dropTable(event: CdkDragDrop<Options[]>) {
    const prevIndex = this.optionDataSource.data.findIndex((d) => d === event.item.data);
    moveItemInArray(this.optionDataSource.data, prevIndex, event.currentIndex);
    this.value.options = this.optionDataSource.data;
    this.onChangeAtMulti();
  }

  public onChangeAtMulti() {
    this.optionDataSource.data = this.value.options;
  }

  inputEmit() {
    this.inputValue.emit(this.value);
  }

}
